var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-index-layout',{attrs:{"title":_vm.$tc('lot.name', 2)},scopedSlots:_vm._u([{key:"new-button",fn:function(){return [_c('base-new-button',{staticClass:"mx-4",attrs:{"to":{ path: 'new' },"append":""}})]},proxy:true}])},[_c('ItemGroupLotIndexTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }